module.exports = __webpack_public_path__ + "img/steak.1734c6e0.jpg";